module.exports = __webpack_public_path__ + "static/img/mbgz.b79b52c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/mbgz.jpg
// module id = tjOz
// module chunks = 1